module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "background"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 text-center",
    staticStyle: {
      "position": "fixed",
      "top": "15%"
    }
  }, [_vm._m(0), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.$router.push({
          name: 'login'
        })
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('login')))])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pb-3 pt-3"
  }, [_c('img', {
    staticClass: "logo ml-3",
    attrs: {
      "src": require("../assets/image/logo_L_size.png")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-091dd478!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Main.vue
// module id = 748
// module chunks = 3